import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { HomeIcon } from '@heroicons/react/24/outline';
import CollectionCards from './collectioncards';
import { useParams } from 'next/navigation';
import { CARE, OPAL, WAIPORI, KROME, MAKU, AIO,TUROA } from 'helpers/constants/collection-names';
import { ImageBanner, FullLengthVideo, MultiImageCarousel } from './contentStackComponents';

export type CollectionProps = {
    data?: any;
    image: any;
    card_title: string;
    call_to_action?: any;
    summary?: string;
    card_description?: string;
    tag_line?: string;
};

const Collection = ({ data }: React.PropsWithChildren<CollectionProps>) => {
    const { slug } = useParams();

    /*Since this is collection page only two brands falls under this Caroma & Livewwell*/
    const getCollectionBrandType = () => {
        const categorySlug = (slug as string)?.split('/').at(-1) ?? '';
        const isLiveWell = [CARE, OPAL].indexOf(categorySlug) !== -1;
        const isMethven = [WAIPORI, KROME,TUROA, MAKU, AIO].indexOf(categorySlug) !== -1;

        let brand = 'Caroma', brandLink = 'caroma';
        if (isLiveWell) {
            brand = 'Caroma Livewell';
            brandLink = 'caroma-livewell';
        } else if (isMethven) {
            brand = 'Methven';
            brandLink = 'methven';
        }

        return (
            <>
                <Link link={`/brands/${brandLink}/`}>
                    <span className="whitespace-nowrap capitalize text-primary-black md:text-12 lg:text-10 2xl:text-12">
                        {brand}
                    </span>
                </Link>
            </>
        );
    };

    const renderContentStackComponents = () => {
        const componentList = [];
        const { sections = [] } = data;
        for (let i = 0; i < sections.length; i++) {
            const componentObj = sections[i];
            const compType = Object.keys(componentObj)?.[0];
            const dataToPass = componentObj[compType];

            switch (compType) {
                case "section_with_image_text":
                    componentList.push(<ImageBanner content={dataToPass} />);
                    break;

                case "section_with_video":
                    componentList.push(<FullLengthVideo content={dataToPass} />);
                    break;

                case "section_with_columns":
                    componentList.push(<CollectionCards props={dataToPass} />);
                    break;

                case "multiple_image":
                    componentList.push(<MultiImageCarousel content={dataToPass} />);
                    break;
            }
        }
        return componentList;
    }

    return (
        <>
            <div className="hidden pb-8 pl-48 pr-24 pt-16 md:block md:pl-26 md:pr-12 lg:pl-48 lg:pr-32 xl:pl-58 xl:pr-44 2xl:pl-63 2xl:pr-64 3xl:pl-80">
                <Breadcrumb Separator={<ChevronRightIcon className="mt-1 w-16" />} listClassName="!gap-x-16">
                    <Link link={'/'}>
                        <HomeIcon className="mt-2 w-20" />
                    </Link>
                    <span className="whitespace-nowrap capitalize text-primary-black md:text-12 lg:text-10 2xl:text-12">
                        Brands
                    </span>
                    {getCollectionBrandType()}
                </Breadcrumb>
            </div>

            {renderContentStackComponents()}
        </>
    );
};

export default Collection;
